(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.m-section-header');
      this.megamenu = document.querySelector('mega-menu');
      this.navBar = this.querySelector('.m-header__nav');
      this.headerTop = this.querySelector('.m-header__top-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerMenuIcon = this.querySelector('.m-header-menu-icon');
      this.headerBounds = { top: 0, bottom: this.header ? this.header.offsetHeight : 0 };
      this.headerTop = this.querySelector('.m-header__top-wrapper');
      this.lastHeaderHeight = 0;
      this.lastNavBarHeight = 0;
      this.lastHeaderTopHeight = 0;
      this.megaMenuCollapsed = false;

      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('m-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollTicking = false;
      this.resizeTicking = false;

      this.onScrollHandler = () => {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        requestAnimationFrame(() => {
          this.onScroll();
          this.scrollTicking = false;
        });
      };
      this.onResizeHandler = () => {
        if (this.resizeTicking) return;
        this.resizeTicking = true;
        requestAnimationFrame(() => {
          this.setHeaderHeight();
          if (this.header.classList.contains('scrolled-past-header')) {
            this.setHeaderTopHeight();
          }
          this.headerBounds = { top: 0, bottom: this.header ? this.header.offsetHeight : 0 };
          this.resizeTicking = false;
        });
      };
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
      window.addEventListener('orientationchange', this.onResizeHandler, { passive: true });

      if (this.headerMenuIcon) {
        this.headerMenuIcon.addEventListener('click', this.toggleMenuBar.bind(this));
      }

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('orientationchange', this.onResizeHandler);
      this.scrollTicking = false;
      this.resizeTicking = false;
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();
      }
    }

    toggleMenuBar() {
      if (!this.headerMenuIcon || !this.navBar || !this.headerTop) return;
      if (this.headerMenuIcon.classList.contains('is-open')) {
        this.headerMenuIcon.classList.remove('is-open');
      } else {
        this.headerMenuIcon.classList.add('is-open');
      }
      if (this.navBar.classList.contains('nav-bar-hidden')) {
        this.navBar.classList.remove('nav-bar-hidden');
        this.headerTop.classList.remove('nav-bar-hidden');
      } else {
        this.navBar.classList.add('nav-bar-hidden');
        this.headerTop.classList.add('nav-bar-hidden');
        this.closeGaMegaMenu();
      }
    }

    closeGaMegaMenu() {
      const openPanels = document.querySelectorAll('.ga-mega-panel.ga-mega-panel--open');
      const activeTriggers = document.querySelectorAll('.ga-header-mega__item.is-active');

      if (!openPanels.length && !activeTriggers.length && !document.documentElement.classList.contains('ga-mega-open')) return;

      openPanels.forEach((panel) => panel.classList.remove('ga-mega-panel--open'));
      activeTriggers.forEach((trigger) => trigger.classList.remove('is-active'));
      document.documentElement.classList.remove('ga-mega-open');
      document.body.classList.remove('ga-mega-open');
      document.dispatchEvent(new CustomEvent('ga:mega-menu:closed-by-header'));
    }

    setHeaderTopHeight() {
      if (!this.headerTop) return;
      const height = this.headerTop.offsetHeight;
      if (height === this.lastHeaderTopHeight) return;
      this.lastHeaderTopHeight = height;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    setHeaderHeight() {
      if (!this.header || !this.navBar) return;

      const headerHeight = this.header.offsetHeight;
      if (headerHeight !== this.lastHeaderHeight) {
        this.lastHeaderHeight = headerHeight;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      }

      const navBarHeight = this.navBar.offsetHeight;
      if (navBarHeight !== this.lastNavBarHeight) {
        this.lastNavBarHeight = navBarHeight;
        document.documentElement.style.setProperty('--nav-bar-height', `${navBarHeight}px`);
      }
    }

    createObserver() {
      if (!this.header) return;
      this._intersectionObserver = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this._intersectionObserver.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isHeaderHidden = this.header.classList.contains('m-section-header-hidden');

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.documentElement.classList.add('scrolled-past-header');
        this.setHeaderTopHeight();
        if (!this.headerMenuIcon || !this.headerMenuIcon.classList.contains('is-open')) {
          this.navBar.classList.add('nav-bar-hidden');
          this.headerTop.classList.add('nav-bar-hidden');
          this.closeGaMegaMenu();
        }
        if (this.megamenu && !this.megaMenuCollapsed) {
          this.megamenu.init();
          this.megamenu.close();
          this.megaMenuCollapsed = true;
        }
        this.headerIsAlwaysSticky && this.megamenu && this.megamenu.setAttribute('data-toggle', 'true');
        if (this.preventHide) return;
        if (!isHeaderHidden) this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.megaMenuCollapsed = false;
        if (!this.preventReveal) {
          if (isHeaderHidden) this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          if (!isHeaderHidden) this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.documentElement.classList.remove('scrolled-past-header');
        this.navBar.classList.remove('nav-bar-hidden');
        this.headerTop.classList.remove('nav-bar-hidden');
        if (this.headerMenuIcon) {
          this.headerMenuIcon.classList.remove('is-open');
        }
        this.setHeaderHeight();
        this.megaMenuCollapsed = false;
        this.reset();
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.megamenu && this.megamenu.removeAttribute('data-toggle');
      this.closeGaMegaMenu();
      this.header.classList.add('m-section-header-hidden', 'm-section-header-sticky');
      document.documentElement.classList.add('m-section-header-hidden');
      this.closeLocalizationForm();
      this.closePredictiveSearch();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.megamenu && this.megamenu.setAttribute('data-toggle', 'true');
      this.header.classList.add('m-section-header-sticky', 'animate');
      this.header.classList.remove('m-section-header-hidden');
      document.documentElement.classList.remove('m-section-header-hidden');
    }

    reset() {
      if (this.megamenu && this.megamenu.openDefault && this.megamenu.template === 'index') {
        this.megamenu && this.megamenu.open();
      }
      if (this.currentScrollTop === 0) {
        this.megamenu && this.megamenu.removeAttribute('data-toggle');
      }
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('m-section-header-hidden', 'm-section-header-sticky', 'animate');
    }

    closePredictiveSearch() {
      this.predictiveSearch = this.predictiveSearch || this.header.querySelector('predictive-search');
      if (!this.predictiveSearch || typeof this.predictiveSearch.close !== 'function') return;
      this.predictiveSearch.close(false);
    }

    closeLocalizationForm() {
      this.localization = this.localization || this.header.querySelectorAll('localization-form');
      this.localization.forEach((localization) => {
        if (typeof localization.hidePanel === 'function') {
          localization.hidePanel();
        }
      });
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
